<template>
  <div>
    <v-progress-linear v-if="loadingCharts" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <v-layout row wrap align-center class="mb-4">
      <v-flex xs12 sm5>
        <v-switch
          v-if="!isTransportationOwnerUser"
          v-model="showWeekendRevenue"
          label="Show Weekend Revenue Only"
          hide-details
          class="mt-0 pt-0"
        ></v-switch>
        <v-switch
          v-model="showCombinedVehicleValues"
          label="Show Combined Vehicle Values"
          hide-details
          class="mt-0 pt-0"
        ></v-switch>
      </v-flex>
      <v-flex xs12 sm7 class="chart-view-toggle-wrap">
        <v-btn-toggle v-model="selectedChartView" mandatory class="chart-view-toggle">
          <v-btn
            v-for="option in chartViewOptions"
            :key="option.value"
            :value="option.value"
            small
            flat
          >
            {{ option.text }}
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>

    <v-card class="mb-4">
      <v-card-title>
        <h2>{{ dayChartRender.title }}</h2>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="dayChartOptions"
          :series="dayChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0') + '|' + (showCombinedVehicleValues ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
          :tooltip-extra-html-by-index="dayChartTooltipExtras"
        ></st-apexchart>
        <div v-if="!dayChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.week">
      <v-card-title>
        <h2>{{ weekChartRender.title }}</h2>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="weekChartOptions"
          :series="weekChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0') + '|' + (showCombinedVehicleValues ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
        ></st-apexchart>
        <div v-if="!weekChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.month">
      <v-card-title>
        <h2>{{ monthChartRender.title }}</h2>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="monthChartOptions"
          :series="monthChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0') + '|' + (showCombinedVehicleValues ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
        ></st-apexchart>
        <div v-if="!monthChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.year">
      <v-card-title>
        <h2>{{ yearChartRender.title }}</h2>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="yearChartOptions"
          :series="yearChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0') + '|' + (showCombinedVehicleValues ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
        ></st-apexchart>
        <div v-if="!yearChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.chart-view-toggle-wrap {
  text-align: right;
}

.chart-view-toggle {
  max-width: 100%;
}

@media (max-width: 960px) {
  .chart-view-toggle-wrap {
    text-align: left;
    margin-top: 8px;
  }
}
</style>

<script>
import src from './src'
export default src
</script>
